import lottie from 'lottie-web';

export const Lottie = (function () {
	'use strict';

	let lottieContainers;

	function init() {
		lottieContainers = document.querySelectorAll('.lottie-animation');

		if(lottieContainers.length < 1){
			return;
		}

		lottieContainers.forEach(function (el) {
			const anim = lottie.loadAnimation({
				container: el,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: el.dataset.lottieJson,
			});
		});
	}

	return {
		init: init,
		name: 'banner',
	};
})();
